module.exports = __webpack_public_path__ + "static/tech-07147a57aa5746926d79a422ae5a15bf.jpg";